import { useEffect } from 'react'

export function useApolloSideEffectOnCompleted<T>(
  data: T,
  callback: (data: NonNullable<T>) => void,
) {
  useEffect(() => {
    if (data) {
      callback(data)
    }
  }, [data])
}
